
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;


export const isPDFScanned = async (file: File): Promise<boolean> => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;
    
    let totalTextLength = 0;
    let totalPages = pdf.numPages;
    
    const pagesToCheck = Math.min(3, totalPages);
    
    for (let i = 1; i <= pagesToCheck; i++) {
      const page = await pdf.getPage(i);
      const textContent = await page.getTextContent();
      
      const pageText = textContent.items
        .map((item: any) => item.str)
        .join('')
        .trim();
      
      totalTextLength += pageText.length;
    }
    
    const avgTextPerPage = totalTextLength / pagesToCheck;
    const isScanned = avgTextPerPage < 100;
    
    return isScanned;
  } catch (error) {
    console.error("Error checking PDF:", error);
    return false;
  }
};